module.exports = __webpack_public_path__ + "static/media/babursah-tugrul.d54354cd.jpg";